import { pletApiRequest } from './client';

export const BackupAPI = {
  export: async () => {
    const result = await pletApiRequest('/export');
    return result;
  },

  import: async (payload, strategy = 'overwrite') => {
    const result = await pletApiRequest('/import', {
      method: 'POST',
      body: JSON.stringify({ ...payload, strategy }),
    });
    return result;
  },
};
